module.exports = __webpack_public_path__ + "static/client-1-66ec3a29dd75cca77d14ef64dbcf1f3a.jpg";